import React from 'react';

/**
 * Bloque informativo para usuarios en Venezuela que aun no tienen USDT.
 * Recomienda formas legales y conocidas de obtener USDT. No es publicidad pagada.
 */
const VenezuelaEducationBlock = () => {
  return (
    <div
      data-testid="ve-education-block"
      className="rounded-2xl border border-cyan-200 bg-gradient-to-br from-cyan-50 to-blue-50 p-5 space-y-3"
    >
      <div className="flex items-start gap-3">
        <div className="text-2xl">{'\u{1F4DA}'}</div>
        <div className="flex-1">
          <h3 className="font-bold text-cyan-900 text-base">¿Aún no tienes USDT?</h3>
          <p className="text-xs text-cyan-800 mt-1">
            En Venezuela puedes obtener tu primer USDT en pocos minutos desde tu telefono.
            Estas son aplicaciones populares y conocidas:
          </p>
        </div>
      </div>
      <div className="grid sm:grid-cols-3 gap-2">
        <a
          href="https://p2p.binance.com/es-LA/trade/all-payments/USDT?fiat=VES"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="ve-edu-link-binance"
          className="block rounded-lg border border-cyan-200 bg-white p-3 hover:border-cyan-400 hover:shadow-sm transition"
        >
          <div className="text-xs font-bold text-cyan-900">Binance P2P</div>
          <div className="text-[10px] text-gray-600 mt-0.5">Compra USDT con Bs. directamente</div>
        </a>
        <a
          href="https://reserve.org/app"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="ve-edu-link-reserve"
          className="block rounded-lg border border-cyan-200 bg-white p-3 hover:border-cyan-400 hover:shadow-sm transition"
        >
          <div className="text-xs font-bold text-cyan-900">Reserve</div>
          <div className="text-[10px] text-gray-600 mt-0.5">App popular en Venezuela</div>
        </a>
        <a
          href="https://cashea.app"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="ve-edu-link-cashea"
          className="block rounded-lg border border-cyan-200 bg-white p-3 hover:border-cyan-400 hover:shadow-sm transition"
        >
          <div className="text-xs font-bold text-cyan-900">Cashea</div>
          <div className="text-[10px] text-gray-600 mt-0.5">Plataforma local con USDT</div>
        </a>
      </div>
      <p className="text-[10px] text-cyan-700 italic">
        CUALAPP no recibe comision por estos enlaces ni esta afiliado a estas plataformas.
        Solo son referencias informativas para usuarios que recien empiezan con USDT.
      </p>
    </div>
  );
};

export default VenezuelaEducationBlock;
